export const SAMPLE_DATA = {
  lots: [
    {
      id: "LOT001",
      farmer: "Ramesh Patil",
      crop: "Tomato",
      quantity: 500,
      grade: "A",
      price: 20,
    },
    {
      id: "LOT002",
      farmer: "Suresh Yadav",
      crop: "Onion",
      quantity: 800,
      grade: "B",
      price: 15,
    },
  ],

  bids: [
    {
        id: 1,
        lotId: "LOT1",
        bidder: "Trader A",
        amount: 2100,
        time: "10:30 AM",
    },
    {
        id: 2,
        lotId: "LOT1",
        bidder: "Trader B",
        amount: 2200,
        time: "10:32 AM",
    },
  ],

  payments: [
    { farmer: "Ramesh Patil", amount: 12000, status: "Paid" },
  ],

  logistics: [
    { lotId: "LOT001", status: "Dispatched", vehicle: "MH12AB1234" },
  ],
};